import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { ComboboxMulti } from "@/components/elements/Combobox";
import { TOption } from "@/types/common";

// learning-progress の ComboboxMultiField と同等の見た目 (ラベル + 複数選択コンボボックス)。
// 当パネルは react-hook-form ではなく useState で条件を持つため、value/onChange で制御する。
type BulkSyncComboboxMultiFieldProps = {
  label: string;
  options: TOption[];
  value: string[];
  onChange: (value: string[]) => void;
  loading?: boolean;
  placeholder?: string;
};

export const BulkSyncComboboxMultiField: FC<BulkSyncComboboxMultiFieldProps> = ({
  label,
  options,
  value,
  onChange,
  loading = false,
  placeholder = "選択してください",
}) => (
  <Stack spacing={0.5}>
    <Typography variant="cap12Light">{label}</Typography>
    <ComboboxMulti placeholder={placeholder} options={options} loading={loading} value={value} onChange={onChange} limitTags={1} />
  </Stack>
);
